import { cn } from '@/lib/utils'

export interface AspectRatioOption {
  value: string
  label: string
  description: string
}

const DEFAULT_ASPECT_RATIOS: AspectRatioOption[] = [
  { value: '1:1', label: 'Square', description: '1:1' },
  { value: '16:9', label: 'Landscape', description: '16:9' },
  { value: '9:16', label: 'Portrait', description: '9:16' },
  { value: '4:3', label: 'Standard', description: '4:3' },
  { value: '3:4', label: 'Portrait', description: '3:4' },
  { value: '3:2', label: 'Photo', description: '3:2' },
  { value: '2:3', label: 'Photo Portrait', description: '2:3' },
]

interface AspectRatioSelectorProps {
  value: string
  onChange: (value: string) => void
  disabled?: boolean
  ratios?: AspectRatioOption[]
}

export function AspectRatioSelector({
  value,
  onChange,
  disabled = false,
  ratios = DEFAULT_ASPECT_RATIOS,
}: AspectRatioSelectorProps) {
  return (
    <div className="flex flex-wrap gap-2">
      {ratios.map((ratio) => (
        <button
          key={ratio.value}
          type="button"
          onClick={() => !disabled && onChange(ratio.value)}
          disabled={disabled}
          className={cn(
            'px-3 py-2 border rounded-lg text-sm font-medium transition-colors',
            value === ratio.value
              ? 'border-blue-500 bg-blue-50 text-blue-700'
              : 'border-gray-200 text-gray-700 hover:border-gray-300',
            disabled && 'opacity-50 cursor-not-allowed'
          )}
        >
          <span className="block">{ratio.description}</span>
        </button>
      ))}
    </div>
  )
}
